import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/nivelPuesto/importer/nivelPuestoImporterActions';

export default importerReducers(actions);
